import clsx from 'clsx';
import type { VacationPeriod } from '@/features/Collaborators/Edit/Types';
import { countVacationDays } from '@/features/Collaborators/Edit/Form/Fieldsets/VacationFieldset/vacationPeriodTotals';
import { formatDateSafe } from '@/utils/dateUtils';
import {
  MANUAL_PERIODS_HEADER,
  MANUAL_PERIODS_EMPTY,
  MANUAL_SECTION_TITLE,
} from '../vacationRequestHistory.definitions';

interface ManualPeriodsSectionProps {
  periods: VacationPeriod[];
}

export function ManualPeriodsSection({ periods }: ManualPeriodsSectionProps) {
  if (!periods || periods.length === 0) {
    return null;
  }

  // Ordenar por startDate decrescente
  const sorted = [...periods].sort((a, b) => {
    const aDate = a.startDate || '';
    const bDate = b.startDate || '';
    return bDate.localeCompare(aDate);
  });

  return (
    <div className="mt-6">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">{MANUAL_SECTION_TITLE}</h3>
        <p className="text-xs text-gray-600 mt-1">{MANUAL_PERIODS_HEADER}</p>
      </div>

      {sorted.length === 0 ? (
        <p className="text-sm text-gray-500">{MANUAL_PERIODS_EMPTY}</p>
      ) : (
        <div className="space-y-2">
          {sorted.map((period, idx) => {
            const days = countVacationDays(period.startDate, period.endDate);
            return (
              <div
                key={idx}
                className={clsx(
                  'border rounded-lg px-4 py-3',
                  'flex items-start justify-between gap-3'
                )}
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-gray-900">
                      {formatDateSafe(period.startDate)} a {formatDateSafe(period.endDate)}
                    </span>
                    <span className="text-xs text-gray-600">
                      {days} {days === 1 ? 'dia' : 'dias'}
                    </span>
                  </div>
                  {period.observations && (
                    <p className="text-xs text-gray-500 mt-1">{period.observations}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
